import { Injectable } from "@nestjs/common";
import { DataSource, In } from "typeorm";
import * as fs from 'fs';
import * as path from 'path';
import { LevisOrdersRepository } from "./repositories/levis-orders.repo";
import { LevisPdfRepo } from "./repositories/levis-pdf.repo";
import { LevisPdfInfoEntity } from "./entities/levis-pdf.entity";
import { CoLineRequest, CommonResponseModel, LevisCoLinereqModel, LevisColorModel, LevisCompareModel, LevisDestinationModel, LevisOrderFilter, LevisSizeModel, LevisSizeWiseModel, LevisSizeWiseReportModel, LevisSplitCompareModel, SizeModel, StatusEnum, levisOrderDataModel, levisOrderReportDataModel } from "@project-management-system/shared-models";
import { LevisCOLineEntity } from "./entities/levis-co-line.entity";
import { LevisCOLineRepository } from "./repositories/levis-co-line.repository";
import { ItemNoDtos } from "../sanmar/dto/sanmar-item-no.dto";
import { OrderDetailsReq } from "../ralph-lauren/dto/order-details-req";
import { ColorRepository } from "../Entites@Shahi/color/color-repo";
import { SizeRepository } from "../Entites@Shahi/size/size-repo";
import { AddressRepository } from "../Entites@Shahi/address/address.repo";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { LevisOrdersChildRepository } from "./repositories/levis-orders-child.repo";
import { LevisOrderschildEntity } from "./entities/levis-orders-child-entity";
import * as nodemailer from 'nodemailer';
import { PDFDocument } from 'pdf-lib';
// const { PDFDocument } = require('pdf-lib')
const PDFParser = require('pdf-parse');


const { Builder, Browser, By, Select, until, Key } = require('selenium-webdriver');
const moment = require('moment');
import * as puppeteer from 'puppeteer';
import { Cron } from "@nestjs/schedule";
import { GenericTransactionManager } from "../../typeorm-transactions";
import { LevisOrdersEntity } from "./entities/levis-orders.entity";
import { EditLevisCOLineEntity } from "./entities/edit-levis-co-line.entity";
import { EditLevisCOLineRepository } from "./repositories/edit-levis-co-line.repository";
import { text } from "stream/consumers";
import { Checkbox } from "antd";
import { first } from "rxjs";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";


// declare var i;
// declare var counter;

@Injectable()
export class LevisService {


  constructor(
    private dataSource: DataSource,
    private LevisOrdersRepo: LevisOrdersRepository,
    private pdfRepo: LevisPdfRepo,
    private levisCoLineRepo: LevisCOLineRepository,
    private colorRepo: ColorRepository,
    private sizeRepo: SizeRepository,
    private AddressRepo: AddressRepository,
    private AddressService: AddressService,
    private LevisOrdersChildRepo: LevisOrdersChildRepository,
    private EditRepo: EditLevisCOLineRepository



  ) { }

  // async saveLevisOrder(req: any): Promise<CommonResponseModel> {
  //   console.log(req, "reqqqqqqqqqqqqq")
  //   // const transactionManager = new GenericTransactionManager(this.dataSource)
  //   try {
  //     let saved
  //     // await transactionManager.startTransaction()
  //     for (const item of req.LevispoItemDetails) {
  //       const match = item.poLine.match(/\d+/);
  //       console.log(match, "match");
  //       // Check if a match is found and convert it to an integer
  //       // const poLine = match ? parseInt(match[0], 10) : null;
  //       const poLine = match

  //       console.log(poLine, "poLine")
  //       for (const variant of item.LevispoItemVariantDetails) {
  //         const orderData = await this.LevisOrdersRepo.findOne({ where: { poNumber: req.poNumber, poLine: poLine, size: variant.size } })
  //         const order = await this.LevisOrdersChildRepo.findOne({ where: { poNumber: req.PoNumber, poLine: poLine, size: variant.size }, order: { poVersion: 'DESC' } })
  //         console.log(orderData, "orderData")
  //         console.log(order, "order")
  //         const entity = new LevisOrdersEntity();
  //         entity.poNumber = req.poNumber
  //         entity.deliveryAddress = req.deliveryAddress
  //         // entity.transMode = req.transMode
  //         entity.currency = req.currency

  //         entity.poLine = item.poLine
  //         entity.material = item.material
  //         // entity.totalUnitPrice = item.totalUnitPrice
  //         // entity.originalDate = item.originalDate
  //         entity.transMode = item.transMode
  //         entity.plannedExFactoryDate = item.plannedExFactoryDate
  //         entity.exFactoryDate = item.exFactoryDate

  //         entity.itemNo = variant.itemNo
  //         // entity.product = variant.product
  //         entity.size = variant.size
  //         entity.upc = variant.upc
  //         // entity.plannedExFactoryDate = variant.plannedExFactoryDate
  //         // entity.exFactoryDate = variant.exFactoryDate
  //         entity.quantity = variant.quantity
  //         entity.unitPrice = variant.unitPrice
  //         entity.scheduledDate = variant.scheduledDate

  //         if (orderData) {
  //           const update = await this.LevisOrdersRepo.update({ poNumber: req.poNumber, poLine: item.poLine, size: variant.size }, {
  //             deliveryAddress:req.deliveryAddress,currency:req.currency,material:item.material,transMode:item.transMode,
  //             size:item.size,upc:variant.upc,quantity:variant.quantity,unitPrice:variant.unitPrice,scheduledDate:variant.scheduledDate
  //           })
  //           let po = parseInt(order?.poVersion) + 1
  //           const entitys= new LevisOrderschildEntity();
  //           entitys.poNumber = req.poNumber
  //           entitys.deliveryAddress = req.deliveryAddress
  //           // entitys.transMode = req.transMode
  //           entitys.currency = req.currency

  //           entitys.poLine = item.poLine
  //           entitys.material = item.material
  //           // entitys.totalUnitPrice = item.totalUnitPrice
  //           // entitys.originalDate = item.originalDate
  //           entitys.transMode = item.transMode
  //           entitys.plannedExFactoryDate = item.plannedExFactoryDate
  //           entitys.exFactoryDate = item.exFactoryDate

  //           entitys.itemNo = variant.itemNo
  //           // entitys.product = variant.product
  //           entitys.size = variant.size
  //           entitys.upc = variant.upc
  //           // entitys.plannedExFactoryDate = variant.plannedExFactoryDate
  //           // entitys.exFactoryDate = variant.exFactoryDate
  //           entitys.quantity = variant.quantity
  //           entitys.unitPrice = variant.unitPrice
  //           entitys.scheduledDate = variant.scheduledDate
  //           entitys.orderId=orderData.id

  //           entitys.poVersion = po.toString()

  //           const savedChild = await this.LevisOrdersChildRepo.save(entitys)
  //           if (!update.affected) {
  //             throw new Error('Update failed');
  //           }
  //         } else {
  //           saved = await this.LevisOrdersRepo.save(entity)
  //           const entitys= new LevisOrderschildEntity();
  //           entitys.poNumber = req.poNumber
  //           entitys.deliveryAddress = req.deliveryAddress
  //           // entitys.transMode = req.transMode
  //           entitys.currency = req.currency

  //           entitys.poLine = item.poLine
  //           entitys.material = item.material
  //           // entitys.totalUnitPrice = item.totalUnitPrice
  //           // entitys.originalDate = item.originalDate
  //           entitys.transMode = item.transMode
  //           entitys.plannedExFactoryDate = item.plannedExFactoryDate
  //           entitys.exFactoryDate = item.exFactoryDate

  //           entitys.itemNo = variant.itemNo
  //           // entitys.product = variant.product
  //           entitys.size = variant.size
  //           entitys.upc = variant.upc
  //           // entitys.plannedExFactoryDate = variant.plannedExFactoryDate
  //           // entitys.exFactoryDate = variant.exFactoryDate
  //           entitys.quantity = variant.quantity
  //           entitys.unitPrice = variant.unitPrice
  //           entitys.scheduledDate = variant.scheduledDate
  //           entitys.orderId=entity.id
  //           const savedChild = await this.LevisOrdersChildRepo.save(entitys)
  //           // const savedChild = await transactionManager.getRepository(RLOrdersEntity).save(entity)
  //           if (!saved) {
  //             throw new Error('Save failed')
  //           }
  //         }
  //       }
  //     }
  //     // await transactionManager.completeTransaction()
  //     return new CommonResponseModel(true, 1, 'Data saved successfully', saved)
  //   } catch (err) {
  //     return new CommonResponseModel(false, 0, 'Failed', err)
  //   }
  // }


  async saveLevisOrder(req: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);

    try {
      let saved;
      const pdfData = [];

      await transactionManager.startTransaction();

      for (const item of req.LevispoItemDetails) {
        for (const variant of item.LevispoItemVariantDetails) {
          const orderData = await this.LevisOrdersRepo.findOne({ where: { poNumber: req.poNumber, poLine: item.poLine, size: variant.size } });
          const order = await this.LevisOrdersChildRepo.findOne({ where: { poNumber: req.poNumber, poLine: item.poLine, size: variant.size }, order: { poVersion: 'DESC' } })

          const entity = new LevisOrdersEntity();
          entity.poNumber = req.poNumber
          entity.deliveryAddress = req.deliveryAddress
          entity.currency = req.currency
          entity.poRemarks = req.poRemarks
          entity.splitPo = req.splitPo
          entity.totalQuantity = req.totalQuantity
          entity.splitPoTotalQuantity = req.splitPoTotalQuantity
          entity.seasonCode = req.seasonCode
          entity.poReceviedDate = req.poReceviedDate

          entity.poLine = item.poLine
          entity.material = item.material
          entity.transMode = item.transMode
          entity.plannedExFactoryDate = item.plannedExFactoryDate
          entity.exFactoryDate = item.exFactoryDate

          entity.itemNo = variant.itemNo
          entity.size = variant.size
          entity.upc = variant.upc
          entity.quantity = variant.quantity
          entity.unitPrice = variant.unitPrice
          entity.scheduledDate = variant.scheduledDate
          entity.status = StatusEnum.OPEN
          pdfData.push(entity);

          // if (orderData) {
          //   // Check if any of the fields have changed
          //   const fieldsChanged = Object.keys(entity).some(key => orderData[key] !== entity[key]);

          //   console.log("update")

          if (orderData) {
            const update = await transactionManager.getRepository(LevisOrdersEntity).update(
              { poNumber: req.poNumber, poLine: item.poLine, size: variant.size },
              {
                deliveryAddress: req.deliveryAddress, currency: req.currency, poRemarks: req.poRemarks, splitPo: req.splitPo, totalQuantity: req.totalQuantity,
                splitPoTotalQuantity: req.splitPoTotalQuantity,
                seasonCode: req.seasonCode, poReceviedDate: req.poReceviedDate,
                material: item.material, transMode: item.transMode, plannedExFactoryDate: item.plannedExFactoryDate, exFactoryDate: item.exFactoryDate,
                itemNo: variant.itemNo, upc: variant.upc, quantity: variant.quantity, unitPrice: variant.unitPrice, scheduledDate: variant.scheduledDate, status: StatusEnum.OPEN
              }
            );
            console.log("update", update)

            let po = parseInt(order?.poVersion) + 1
            const entitys = new LevisOrderschildEntity()

            entitys.poNumber = req.poNumber
            entitys.deliveryAddress = req.deliveryAddress
            entitys.currency = req.currency
            entitys.poRemarks = req.poRemarks
            entitys.splitPo = req.splitPo
            entitys.totalQuantity = req.totalQuantity
            entitys.splitPoTotalQuantity = req.splitPoTotalQuantity
            entitys.seasonCode = req.seasonCode
            entitys.poReceviedDate = req.poReceviedDate

            entitys.poLine = item.poLine
            entitys.material = item.material
            entitys.transMode = item.transMode
            entitys.plannedExFactoryDate = item.plannedExFactoryDate
            entitys.exFactoryDate = item.exFactoryDate

            entitys.itemNo = variant.itemNo
            entitys.size = variant.size
            entitys.upc = variant.upc
            entitys.quantity = variant.quantity
            entitys.unitPrice = variant.unitPrice
            entitys.scheduledDate = variant.scheduledDate
            entitys.poVersion = po.toString()
            entitys.orderId = orderData.id
            entitys.status = StatusEnum.OPEN

            const savedChild = await transactionManager.getRepository(LevisOrderschildEntity).save(entitys)


            if (!update.affected) {
              throw new Error('Update failed');
            }
          }
          // } 
          else {
            // Only save if the record doesn't exist
            saved = await transactionManager.getRepository(LevisOrdersEntity).save(entity);
            const entitys = new LevisOrderschildEntity()

            entitys.poNumber = req.poNumber
            entitys.deliveryAddress = req.deliveryAddress
            entitys.currency = req.currency
            entitys.poRemarks = req.poRemarks
            entitys.splitPo = req.splitPo
            entitys.totalQuantity = req.totalQuantity
            entitys.splitPoTotalQuantity = req.splitPoTotalQuantity
            entitys.seasonCode = req.seasonCode
            entitys.poReceviedDate = req.poReceviedDate

            entitys.poLine = item.poLine
            entitys.material = item.material
            entitys.transMode = item.transMode
            entitys.plannedExFactoryDate = item.plannedExFactoryDate
            entitys.exFactoryDate = item.exFactoryDate

            entitys.itemNo = variant.itemNo
            entitys.size = variant.size
            entitys.upc = variant.upc
            entitys.quantity = variant.quantity
            entitys.unitPrice = variant.unitPrice
            entitys.scheduledDate = variant.scheduledDate
            entitys.orderId = entity.id
            entitys.status = StatusEnum.OPEN

            const savedChild = await await transactionManager.getRepository(LevisOrderschildEntity).save(entitys)


            if (!saved) {
              throw new Error('Save failed');
            }
          }
        }
      }

      await transactionManager.completeTransaction();
      return new CommonResponseModel(true, 1, 'Data saved successfully', saved);
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Failed', err.message || 'Unknown error');
    }
  }



  // async updatePath(req: any, poNumber: string, filePath: string, filename: string, mimetype: string): Promise<CommonResponseModel> {
  //   console.log(poNumber, "pppppioooooo");
  //   const entity = new LevisPdfInfoEntity();
  //   entity.poNumber = poNumber;
  //   entity.pdfFileName = filename;
  //   entity.filePath = filePath;
  //   entity.fileType = mimetype;
  //   entity.fileData = req;
  //   entity.uploadStatus = "SUCCESS";

  //   const file = await this.pdfRepo.findOne({ where: { pdfFileName: filePath } });
  //   if (file) {
  //     return new CommonResponseModel(false, 0, 'File with the same name already uploaded');
  //   } else {
  //     const save = await this.pdfRepo.save(entity);
  //     if (save) {
  //       return new CommonResponseModel(true, 1, 'Uploaded successfully', save);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'Uploaded failed');
  //     }
  //   }
  // }

  async updatePath(req: any, jsonData: any, poNumber: any): Promise<CommonResponseModel> {
    try {

      let flag = true;
      const entities = []
      for (const res of req) {
        const entity = new LevisPdfInfoEntity();
        entity.pdfFileName = res.filename
        entity.filePath = res.path
        entity.poNumber = poNumber
        entity.fileData = jsonData
        entity.fileType = res.mimetype
        entity.createdUser = "admin"
        entity.uploadStatus = "SUCCESS";
        entities.push(entity);
      }
      const uploadDoc = await this.pdfRepo.save(entities);
      if (!uploadDoc) {
        flag = false;
      }
      if (flag) {
        return new CommonResponseModel(true, 11, 'uploaded successfully', req);
      }
      else {
        return new CommonResponseModel(false, 11, 'uploaded failed', req);
      }
    }
    catch (error) {
      console.log(error);
    }
  }






  async getorderacceptanceData(req?: LevisOrderFilter): Promise<CommonResponseModel> {
    // console.log(req, "servvv")
    try {
      const details = await this.LevisOrdersRepo.getorderacceptanceData(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, levisOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`)) {
          sizeDateMap.set(
            `${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`,
            new levisOrderDataModel(rec.id, rec.po_number, rec.delivery_address, rec.transmode, rec.currency, rec.po_line, rec.material, rec.total_unit_price, rec.original_date, rec.status, [], rec.ex_factory_date)
          );

        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unit_price);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new LevisSizeWiseModel(rec.product, rec.size, rec.upc, rec.planned_ex_factory_date, rec.ex_factory_date, rec.quantity, rec.unit_price, rec.item_no));
        }
      }
      const dataModelArray: levisOrderDataModel[] = Array.from(sizeDateMap.values());

      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);



    } catch (e) {
      // console.log(e, "errrrrrrrrr")
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }


  async getPoNumber(): Promise<CommonResponseModel> {
    try {
      const data = await this.LevisOrdersRepo.getPoNumber()
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }


  async coLineCreationReq(req: any): Promise<CommonResponseModel> {
    try {
      // console.log(req,'req')
      if (req.itemNo == undefined || null) {
        return new CommonResponseModel(false, 0, 'Please enter Item No')
      };
      // const update= await this.Repo.update({ where:{ poNumber: req.poNumber ,status:StatusEnum.ACCEPTED}})
      const records = await this.LevisOrdersRepo.find({ where: { poNumber: req.poNumber } });
      const uniquePoLines = [...new Set(records.map((rec) => rec.poLine))];
      const empty = [];

      //console.log(rec,'reccccccccc')
      const entity = new LevisCOLineEntity()
      entity.poLine = uniquePoLines.join(',');
      entity.buyer = req.buyer
      entity.poNumber = req.poNumber;
      entity.material = req.material;
      entity.itemNo = req?.itemNo;
      entity.status = 'Open';
      // entity.deliveryDate = req.deliveryDate;
      entity.createdUser = 'admin';
      empty.push(entity)

      // console.log(empty,'emptyyyyy')
      const save = await this.levisCoLineRepo.save(empty);



      if (save) {
        const update = await this.LevisOrdersRepo.update(
          { poNumber: req.poNumber }, // Conditions for updating
          { status: StatusEnum.INPROGRESS }
        );
        return new CommonResponseModel(true, 1, 'CO-Line request created successfully', save)
      } else {
        return new CommonResponseModel(false, 0, 'CO-Line request failed')
      }
    } catch (err) {
      //  console.log(err,',,,,,,,,,,,,,,,')
      return new CommonResponseModel(false, 0, 'CO-Line request failed', err)
    }
  }


  async getCoLineData(req?: LevisOrderFilter): Promise<CommonResponseModel> {
    const data = await this.levisCoLineRepo.getCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getCoPoNumber(): Promise<CommonResponseModel> {
    const data = await this.levisCoLineRepo.getCoPoNumber()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getItem(): Promise<CommonResponseModel> {
    try {
      const data = await this.levisCoLineRepo.getItem()
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }


  async updateItemNo(req: ItemNoDtos): Promise<CommonResponseModel> {
    console.log(req, "reqq");
    try {
      const update = await this.levisCoLineRepo.update(
        { id: Number(req.id) },
        { itemNo: req.itemNo }
      );

      if (update) {
        return new CommonResponseModel(true, 1, "ItemNo Update Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while updating ItemNo", error);
    }
  }


  async deleteCoLine(req: ItemNoDtos): Promise<CommonResponseModel> {
    console.log(req, "reqq");
    try {
      const deletedItem = await this.levisCoLineRepo.delete({ id: Number(req.id) });

      if (deletedItem && deletedItem.affected) {
        return new CommonResponseModel(true, 1, "ItemNo Deleted Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }


  async getorderDataForInfo(req?: LevisOrderFilter): Promise<CommonResponseModel> {
    console.log(req, "servvv")
    try {
      const details = await this.LevisOrdersRepo.getorderDataForInfo(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, levisOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`)) {
          sizeDateMap.set(
            `${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`,
            new levisOrderDataModel(rec.id, rec.po_number, rec.delivery_address, rec.transmode, rec.currency, rec.po_line, rec.material, rec.total_unit_price, rec.original_date, rec.status, [], rec.ex_factory_date)
          );

        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unit_price);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new LevisSizeWiseModel(rec.product, rec.size, rec.upc, rec.planned_ex_factory_date, rec.ex_factory_date, rec.quantity, rec.unit_price, rec.item_no));
        }
      }
      const dataModelArray: levisOrderDataModel[] = Array.from(sizeDateMap.values());

      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);



    } catch (e) {
      console.log(e, "errrrrrrrrr")
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }


  async updateStatusInOrder(req: any): Promise<CommonResponseModel> {
    console.log(req, "reqOpenStatus")
    try {
      const update = await this.LevisOrdersRepo.update(
        { poNumber: req.poNumber },
        { status: StatusEnum.OPEN }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "Updated Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  async getPdfFileInfo(req: any): Promise<CommonResponseModel> {
    console.log(req, 'reqqqqqqqq')
    try {
      const data = await this.pdfRepo.getPDFInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  // async getOrderdataForCOline(req: OrderDetailsReq): Promise<CommonResponseModel> {
  //   try {
  //     const data = await this.LevisOrdersRepo.find({ where: { poNumber: req.poNumber } })

  //     // po -> destination -> color -> sizes
  //     const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
  //     const poMap = new Map<string, LevisOrdersEntity>();
  //     data.forEach(rec => {
  //       poMap.set(`${rec.poNumber}`, rec)
  //       // const destCountry = rec.shipToAdd.slice(-13).trim();
  //       // console.log(destCountry,"hirrrrrrrrrrrrrrrrrr")

  //       // const parts = rec.deliveryAddress.split(',')
  //       // const destAdd = parts[2].trim();
  //       // const dest = destAdd;
  //       const dest = rec.deliveryAddress;


  //       if (!destinationColSizesMap.has(`${rec.poNumber}`)) {
  //         destinationColSizesMap.set(`${rec.poNumber}`, new Map<string, Map<string, []>>());
  //       }
  //       if (!destinationColSizesMap.get(`${rec.poNumber}`).has(dest)) {
  //         destinationColSizesMap.get(`${rec.poNumber}`).set(dest, new Map<string, []>());
  //       }

  //       const check = await this.colorRepo.find({
  //         where: {
  //           colorCode: rec.product
  //         }
  //       });

  //       if (!destinationColSizesMap.get(`${rec.poNumber}`).get(dest).has(rec.product)) {
  //         destinationColSizesMap.get(`${rec.poNumber}`).get(dest).set(rec.product, []);
  //       }
  //       destinationColSizesMap.get(`${rec.poNumber}`).get(dest).get(rec.product).push({ size: rec.size, quantity: rec.quantity, price: rec.unitPrice });
  //     });
  //     const coData = []
  //     destinationColSizesMap.forEach((destColorSize, poNumber) => {
  //       const desArray = []
  //       destColorSize.forEach((colorSizes, dest) => {
  //         const ColArray = []
  //         colorSizes.forEach((sizes, color) => {
  //           const sizeArray = []
  //           sizes.forEach((size) => {
  //             const sizeObj = new LevisSizeModel(size.size, size.quantity, size.price);
  //             sizeArray.push(sizeObj)
  //           })
  //           const col = new LevisColorModel(color, sizeArray);
  //           ColArray.push(col)
  //         });
  //         const des = new LevisDestinationModel(dest, ColArray);
  //         desArray.push(des)
  //       });
  //       const poInfo = poMap.get(poNumber)
  //       const co = new LevisCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.currency, poInfo.plannedExFactoryDate, desArray);
  //       coData.push(co)
  //     });
  //     if (coData) {
  //       return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', coData);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     throw err
  //   }
  // }

  // async getOrderdataForCOline(req: OrderDetailsReq): Promise<CommonResponseModel> {
  //   try {
  //     // const poLineValues = req.poLine.split(',')
  //     const poLineValues = req?.poLine
  //     const data = await this.LevisOrdersRepo.find({ where: { poNumber: req.poNumber, poLine: poLineValues } });
  //     // const exfacDate = data[0]?.exFactoryDate
  //     // console.log(exfacDate,"exfacDate")


  //     // const [day, month, year] = exfacDate?.split('.');
  //     // const inputDate = new Date(`${year}-${month}-${day}`);


  //     // const FourteenDaysafter = new Date(inputDate);
  //     // FourteenDaysafter.setDate(inputDate.getDate() + 14);
  //     // const DeliveryDate = new Intl.DateTimeFormat('en-GB').format(FourteenDaysafter);
  //     // console.log(DeliveryDate,"DeliveryDate")


  //     // po -> destination -> color -> sizes
  //     const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
  //     const poMap = new Map<string, LevisOrdersEntity>();

  //     for (const rec of data) {
  //       poMap.set(`${rec.poNumber}`, rec);
  //       // const dest = rec.deliveryAddress;
  //       const parts = rec.deliveryAddress.split(',')
  //       const destAdd = parts[0].trim();
  //       const dest = destAdd;


  //       if (!destinationColSizesMap.has(`${rec.poNumber}`)) {
  //         destinationColSizesMap.set(`${rec.poNumber}`, new Map<string, Map<string, []>>());
  //       }
  //       if (!destinationColSizesMap.get(`${rec.poNumber}`).has(dest)) {
  //         destinationColSizesMap.get(`${rec.poNumber}`).set(dest, new Map<string, []>());
  //       }
  //       console.log(rec.material, "material")
  //       const colorcheck = await this.colorRepo.findOne({
  //         where: {
  //           colorCode: rec.material
  //         }
  //       });

  //       console.log(colorcheck, "color")
  //       if (colorcheck) {
  //         if (!destinationColSizesMap.get(`${rec.poNumber}`).get(dest).has(colorcheck.colorName)) {
  //           destinationColSizesMap.get(`${rec.poNumber}`).get(dest).set(colorcheck.colorName, []);
  //         }

  //       }

  //       const sizecheck = await this.sizeRepo.findOne({
  //         where: {
  //           poSize: rec.size
  //         }
  //       });

  //       if (sizecheck) {

  //         destinationColSizesMap.get(`${rec.poNumber}`).get(dest).get(colorcheck.colorName).push({ size: sizecheck.crmSize, quantity: rec.quantity, price: rec.unitPrice });

  //       } else {

  //         destinationColSizesMap.get(`${rec.poNumber}`).get(dest).get(colorcheck.colorName).push({ size: rec.size, quantity: rec.quantity, price: rec.unitPrice });
  //       }

  //     }

  //     const coData = [];
  //     destinationColSizesMap.forEach((destColorSize, poNumber) => {
  //       const desArray = [];
  //       destColorSize.forEach((colorSizes, dest) => {
  //         const ColArray = [];
  //         colorSizes.forEach((sizes, color) => {
  //           const sizeArray = [];
  //           sizes.forEach((size) => {
  //             const sizeObj = new LevisSizeModel(size.size, size.quantity, size.price);
  //             sizeArray.push(sizeObj);
  //           });
  //           const col = new LevisColorModel(color, sizeArray);
  //           ColArray.push(col);
  //         });
  //         const des = new LevisDestinationModel(dest, ColArray);
  //         desArray.push(des);
  //       });
  //       const poInfo = poMap.get(poNumber);

  //       const parsedDate = moment(poInfo?.exFactoryDate, "DD.MM.YYYY");
  //       let formattedExFactDate = parsedDate.format("DD/MM/YYYY");

  //       if (parsedDate.isSameOrBefore(moment(), 'day')) {
  //         formattedExFactDate = '';
  //       }



  //       const co = new LevisCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.currency, formattedExFactDate, formattedExFactDate, poInfo.material, desArray);
  //       coData.push(co);
  //     });

  //     if (coData.length > 0) {
  //       return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  async getOrderdataForCOline(req: OrderDetailsReq): Promise<CommonResponseModel> {
    try {
      const poLineValues = req?.poLine;
      const data = await this.LevisOrdersRepo.find({ where: { poNumber: req.poNumber, poLine: poLineValues } });

      const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
      const poMap = new Map<string, LevisOrdersEntity>();

      for (const rec of data) {
        poMap.set(`${rec.poNumber}`, rec);
        const parts = rec.deliveryAddress.split(',');
        const destAdd = parts[0].trim();
        const dest = destAdd;

        if (!destinationColSizesMap.has(`${rec.poNumber}`)) {
          destinationColSizesMap.set(`${rec.poNumber}`, new Map<string, Map<string, []>>());
        }
        if (!destinationColSizesMap.get(`${rec.poNumber}`).has(dest)) {
          destinationColSizesMap.get(`${rec.poNumber}`).set(dest, new Map<string, []>());
        }

        const colorcheck = await this.colorRepo.findOne({
          where: {
            colorCode: rec.material
          }
        });

        const colorName = colorcheck ? colorcheck.colorName : '';
        if (!destinationColSizesMap.get(`${rec.poNumber}`).get(dest).has(colorName)) {
          destinationColSizesMap.get(`${rec.poNumber}`).get(dest).set(colorName, []);
        }

        const sizecheck = await this.sizeRepo.findOne({
          where: {
            poSize: rec.size
          }
        });

        if (sizecheck) {
          destinationColSizesMap.get(`${rec.poNumber}`).get(dest).get(colorName).push({ size: sizecheck.crmSize, quantity: rec.quantity, price: rec.unitPrice });
        } else {
          destinationColSizesMap.get(`${rec.poNumber}`).get(dest).get(colorName).push({ size: rec.size, quantity: rec.quantity, price: rec.unitPrice });
        }
      }

      const coData = [];
      destinationColSizesMap.forEach((destColorSize, poNumber) => {
        const desArray = [];
        destColorSize.forEach((colorSizes, dest) => {
          const ColArray = [];
          colorSizes.forEach((sizes, color) => {
            const sizeArray = [];
            sizes.forEach((size) => {
              const sizeObj = new LevisSizeModel(size.size, size.quantity, size.price);
              sizeArray.push(sizeObj);
            });
            const col = new LevisColorModel(color, sizeArray);
            ColArray.push(col);
          });
          const des = new LevisDestinationModel(dest, ColArray);
          desArray.push(des);
        });
        const poInfo = poMap.get(poNumber);

        const parsedDate = moment(poInfo?.exFactoryDate, "DD.MM.YYYY");
        let formattedExFactDate = parsedDate.format("DD/MM/YYYY");

        if (parsedDate.isSameOrBefore(moment(), 'day')) {
          formattedExFactDate = '';
        }

        const co = new LevisCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.currency, formattedExFactDate, formattedExFactDate, poInfo.material, desArray);
        coData.push(co);
      });

      if (coData.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      throw err;
    }
  }



  async getordercomparationData(req?: any): Promise<CommonResponseModel> {
    try {
      const Originaldata = await this.LevisOrdersRepo.getordercomparationData(req)
      const compareModel: LevisCompareModel[] = []

      for (const rec of Originaldata) {
        //console.log(rec, "rec")
        const itemNumber = await this.LevisOrdersRepo.getItemsNo(rec.po_number)
        const coNumber = await this.LevisOrdersRepo.getItemsNo(rec.po_number)
        const coDate = await this.LevisOrdersRepo.getItemsNo(rec.po_number)
        // console.log(itemNumber, 'kkkkkkkkkkkkkkkk')
        // console.log(coNumber, 'lllllllllll')
        // console.log(coDate, 'mmmmmmmm')
        const childData = await this.LevisOrdersChildRepo.find({
          where: {
            poNumber: rec.po_number, poLine: rec.po_line, size: rec.size
          }, order: { id: 'DESC' }, take: 1, skip: 1
        })
        if (childData.length > 0) {
          const oldData = childData[0];
          // Check for changes in values
          if (
            oldData.unitPrice !== rec.unit_price ||
            oldData.exFactoryDate !== rec.ex_factory_date ||
            oldData.quantity !== rec.quantity ||
            oldData.transMode !== rec.transmode ||
            oldData.deliveryAddress !== rec.delivery_address
          ) {
            // Only push if there are changes
            compareModel.push(new
              LevisCompareModel(
                rec.po_number,
                rec.po_line,
                rec.size,
                oldData.unitPrice,
                rec.unit_price,
                oldData.exFactoryDate,
                rec.ex_factory_date,
                oldData.quantity,
                rec.quantity,
                oldData.transMode,
                rec.transmode,
                oldData.deliveryAddress,
                rec.delivery_address,
                oldData.status,
                itemNumber?.item_no ? itemNumber?.item_no : "-",
                coNumber?.co_number,
                coDate?.co_date,
                rec.material

              ));
          }
        }
      }
      if (compareModel) {

        return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', compareModel);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      throw err
    }
  }

  @Cron('*/5 * * * *')
  async createCOline(req: any): Promise<CommonResponseModel> {
    const [po] = await this.levisCoLineRepo.getDataforCOLineCreation();
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      // for (const po of poDetails) {
      console.log(po)
      const coLine = new CoLineRequest();
      let agent;
      let buyerAddress;
      let deliveryAddress;
      let pkgTerms;
      let paymentTerms;
      let styleNo;
      let paymentMethod;
      if (po.buyer === 'LEVIS') {

        const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Inprogress' });
        console.log(update, "uuuupdate")

        const response = await this.getOrderdataForCOline({ poNumber: po.po_number, poLine: po.po_line })
        console.log(response.data[0], "response")
        const coData = response.data[0];
        coLine.buyerPo = coData.poNumber
        // const inputDate = new Date(coData.deliveryDate)
        // Calculate the date 7 days before the GAC date
        // const sevenDaysBefore = new Date(inputDate);
        // sevenDaysBefore.setDate(inputDate.getDate() - 7);
        // const exFactoryDate = new Intl.DateTimeFormat('en-GB').format(sevenDaysBefore);

        coLine.deliveryDate = coData.deliveryDate
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        coLine.exFactoryDate = coData.exfactoryDate

        console.log(coLine.exFactoryDate, "exFactoryDate")
        console.log(coLine.deliveryDate, "deliveryDate")

        const request = coData.destinations[0]?.name;
        console.log(request, "request")
        const address = await this.AddressService.getAddressInfoByCountry({ country: request });
        const addressData = address.data[0];
        console.log("----------------start----------------")

        if (!addressData) {
          const update = await this.levisCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
          return new CommonResponseModel(false, 0, "Address not matching");
          // throw new ErrorResponse(0, "Address not matching")
        }

        console.log("----------------end----------------")

        console.log(addressData, "address")
        styleNo = coData.style
        buyerAddress = addressData?.buyerAddressCode
        deliveryAddress = addressData?.deliveryAddressCode
        agent = "-NA"
        pkgTerms = "STD-STD PACK"
        paymentTerms = "063-TT  75 Days"
        paymentMethod = "BTR-Bank Transfer"
      }
      console.log("abc")

      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Style Order')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }
      console.log("xyz")
      await driver.wait(until.elementLocated(By.id('styleid2H')))
      await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
      console.log("1245789632")
      await driver.sleep(5000)

      if (coLine.currency === "INR") {
        await driver.wait(until.elementLocated(By.id('bgpset1')));
        const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
        const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
        await dropdown1.selectByValue("LIV-LIVIS")
        await driver.sleep(5000)

        await driver.wait(until.elementLocated(By.id('byr')));
        const dropdownElement2 = await driver.findElement(By.id('byr'));
        const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
        await dropdown2.selectByValue("LEVI0001-LEVI STRAUSS INDIA PVT LTD")
      } else {
        await driver.wait(until.elementLocated(By.id('bgpset1')));
        const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
        const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
        await dropdown1.selectByValue("LEV-LEVIS")
        await driver.sleep(5000)

        await driver.wait(until.elementLocated(By.id('byr')));
        const dropdownElement2 = await driver.findElement(By.id('byr'));
        const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
        await dropdown2.selectByValue("LEV00002-LEVI STRAUSS GLOBAL TRADING CO LTD")
      }
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('CreateOrderID')))
      await driver.sleep(3000)
      await driver.findElement(By.id('CreateOrderID')).click();
      await driver.wait(until.elementLocated(By.id('bpo')))
      await driver.findElement(By.id('bpo')).clear();
      await driver.findElement(By.id('bpo')).sendKeys(coLine.buyerPo);
      await driver.wait(until.elementLocated(By.id('bus')))
      await driver.findElement(By.id('bus')).clear();
      await driver.findElement(By.id('bus')).sendKeys(styleNo);
      await driver.wait(until.elementLocated(By.id('agnt')));
      const agentDropDown = await driver.findElement(By.id('agnt'));
      await driver.executeScript(`arguments[0].value = '${agent}';`, agentDropDown)
      await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate);
      await driver.wait(until.elementLocated(By.name('dojo.delydt')));
      await driver.findElement(By.name('dojo.delydt')).clear();
      await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate);
      await driver.wait(until.elementLocated(By.name('byd')));
      const dropdown = await driver.findElement(By.name('byd'));
      const options = await dropdown.findElements(By.tagName('option'));
      const optionValues = [];
      for (const option of options) {
        const value = await option.getAttribute('value');
        optionValues.push(value);
      }
      const number = optionValues.find(value => {
        return Number(value.split('-')[0].trim()) == Number(buyerAddress)
      });
      // const number = optionValues.find(value => value.includes(buyerAddress)); // give the dynamic value here
      await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
      await driver.wait(until.elementLocated(By.xpath('//*[@id="cur"]')));
      const curDropdown = await driver.findElement(By.xpath('//*[@id="cur"]'));
      const cur = coLine.currency; // give the dynamic value here
      await driver.executeScript(`arguments[0].value = '${cur}';`, curDropdown);

      await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
      await driver.findElement(By.xpath('//*[@id="price"]')).clear();
      await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice);

      await driver.wait(until.elementLocated(By.id('packtrm')));
      const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
      await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)

      await driver.wait(until.elementLocated(By.id('ptr')));
      const ptrDropDown = await driver.findElement(By.id('ptr'));
      await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)

      await driver.wait(until.elementLocated(By.id('pmt')));
      const payMentMethodDropDown = await driver.findElement(By.id('pmt'));
      await driver.executeScript(`arguments[0].value = '${paymentMethod}';`, payMentMethodDropDown)
      await driver.sleep(10000)
      for (let dest of coLine.destinations) {
        const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
        const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
        for (const tab of colorsTabs) {
          if ((await tab.getAttribute('innerText')) == dest.name) {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  }
                }
                const inputId = `${size.name}:${color.name}:${dest.name}`.replace(/\*/g, '');
                const input = await driver.wait(until.elementLocated(By.id(inputId)))
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  console.log(number, "nummmm")
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                    await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                    // return new CommonResponseModel(false, 0, 'NO matching Size found')
                    throw new ErrorResponse(0, "NO matching Size found")
                  }
                }
                const inputId = `${size.name}:${color.name}:ASSORTED`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASORTED') {
            await driver.executeScript('arguments[0].click();', tab);

            let tabIndex = 1; // Default to 1 if no match
            // if ((await tab.getAttribute('innerText')) == 'ASORTED') {
            //   tabIndex = 2
            // }

            const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
            await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
            const dropdown = await driver.findElement(By.id(`bydline/${string}`));
            const options = await dropdown.findElements(By.tagName('option'));
            const optionValues = [];
            for (const option of options) {
              const value = await option.getAttribute('value');
              optionValues.push(value);
            }
            const number = optionValues.find(value => {
              return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
            });
            console.log(number, "nummmm")
            // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
            await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }

                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;

                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                    await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                    // return new CommonResponseModel(false, 0, 'NO matching Size found')
                    throw new ErrorResponse(0, "NO matching Size found")
                  }
                }
                const inputId = `${size.name}:${color.name}:ASORTED`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                console.log(size.qty, 'QQQQQQQQ')
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                console.log("122222")
              }
              console.log("587888")
            }
          }
        }
      }
      await driver.sleep(10000)
      const element = await driver.findElement(By.id('OrderCreateID')).click();
      await driver.wait(until.alertIsPresent(), 10000);
      const alert = await driver.switchTo().alert();
      await alert.accept();
      if (await this.isAlertPresent(driver)) {
        const alert = await driver.switchTo().alert();
        const alertText = await alert.getText();
        const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: alertText, isActive: false });
        await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
        await alert.accept();
        await driver.sleep(5000)
        await driver.navigate().refresh();
        await driver.quit();
        return new CommonResponseModel(false, 0, alertText)
      } else {
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
        const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
        const coNo = await coNoElement.getAttribute('value');
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        if (coNo) {
          const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { coNumber: coNo, status: 'Success', coDate: currentDateFormatted, errorMsg: "-" });
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.SUCCESS })
          await driver.sleep(5000)
        } else {
          const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false });
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
          const emailBot = await this.getCoLineDataAndSendEmail()
          console.log(emailBot, "emailBotTimeOut")
          await driver.sleep(5000)
        }
      }
      return new CommonResponseModel(true, 1, `COline created successfully`)
    } catch (error) {
      console.log(error, 'error');
      const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false });
      await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
      const emailBot = await this.getCoLineDataAndSendEmail()
      console.log(emailBot, "emailBot")
      return new CommonResponseModel(false, 0, error)
    }
    finally {
      driver.quit()
    }
  }

  async isAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }

  async getCoLineDataAndSendEmail(): Promise<CommonResponseModel> {
    const formatDate = (date: Date): string => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    try {
      const today = new Date();
      const todaysDate = formatDate(today);
      console.log(todaysDate, "Today's Date");

      const response = await this.levisCoLineRepo.getCoLineData();
      const data = response || [];

      const updatedData = data.map(item => {
        return {
          ...item,
          updated_at: item.updated_at ? new Date(item.updated_at).toISOString().split('T')[0] : null
        };
      });
      console.log(updatedData, "Updated Records");
      const coLineFailedData = updatedData.filter(item =>
        item.updated_at === todaysDate && item.status === "Failed"
      );
      console.log(coLineFailedData, `Failed Records On ${todaysDate}`);
      console.log(coLineFailedData[0], `Failed Records On ${todaysDate} of Object One`);

      if (coLineFailedData.length === 0) {
        return new CommonResponseModel(false, 0, `No Records With Failed Status On ${todaysDate}`);
      }

      const errorMessage = coLineFailedData.map(item => `
        PO Number: ${item.po_number}
        Buyer Name: Levis
        PO Line: ${item.po_line}
        PLM Style: ${item.material}
        Item No: ${item.item_no}
        CO Number: ${item.co_number}
        CO Date: ${item.co_date}
        Status: ${item.status}
        Message: ${item.error_msg}
      `).join('\n\n');

      const recipientEmail = 'santhosh.palaksha@shahi.co.in';
      const ccEmails = [
        'saiprakash.katiki@gmail.com', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com',
        'sujatha@schemaxtech.com', 'bala.arumugam@shahi.co.in', 'moshika.murugan@shahi.co.in',
        'priya.prabhakaran@shahi.co.in', 'senguttuvan.ilangovan@shahi.co.in',
        'vignesh.prabhakaran@shahi.co.in', 'santhosh.palaksha@shahi.co.in'
      ];

      const transporter = nodemailer.createTransport({
        host: 'smtp.gmail.com',
        port: 587,
        secure: false,
        auth: {
          user: 'alerts@schemaxtech.com',
          pass: 'mzep lrqi mczj uezj'
        }
      });

      const mailOptions = {
        from: 'alerts@schemaxtech.com',
        to: recipientEmail,
        cc: ccEmails,
        subject: 'Levis CO Line Failed Status',
        text: `Dear User,\n\n Levis CO Line Data:\n\n${errorMessage}\n\nRegards,\nLEVIS BOT`,
      };
      await transporter.sendMail(mailOptions);
      return new CommonResponseModel(true, 1, "Email sent successfully");
    } catch (error) {
      console.error("Error sending email:", error);
      return new CommonResponseModel(false, 0, "An error occurred while sending the email");
    }
  }



  async updateCOLineStatus(req: any): Promise<CommonResponseModel> {
    console.log(req, "reqqqqqqqponumnbbb");
    try {
      const poLines = req.poLine.split(","); // Split poLine string into an array

      // Iterate over each poLine and update its status
      for (const poLine of poLines) {
        await this.LevisOrdersRepo.update(
          { poNumber: req.poNumber, poLine: poLine.trim() }, // Trim to remove any extra spaces
          { status: req.status }
        );
      }

      return new CommonResponseModel(true, 1, 'Success'); // Return success response with the number of lines updated
    } catch (error) {
      console.error("Error updating CO line status:", error);
      return new CommonResponseModel(false, 0, 'Failed');
    }
  }


  // @Cron('*1 * * * *')
  // async levisBot() {
  //   const browser = await puppeteer.launch({ headless: false, args: ['--start-maximized'] });
  //   try {
  //     const page = await browser.newPage();
  //     await page.setViewport({ width: 1580, height: 900 });
  //     await page.goto('https://levis.shahiapps.in/', {
  //       timeout: 100000,
  //       waitUntil: 'networkidle0',
  //     })

  //     await page.waitForSelector('#login-form_username');
  //     await page.type('#login-form_username', 'levis@gmail.com');

  //     await page.waitForSelector('#login-form_password');
  //     await page.type('#login-form_password', 'levis');

  //     await page.click('button.ant-btn-primary');
  //     await page.waitForNavigation();

  //     await page.goto('https://levis.shahiapps.in/#/levis/levis-pdf-upload/', {
  //       timeout: 100000,
  //       waitUntil: 'networkidle0'
  //     })

  //     //live directory paths:
  //     const directoryPath = 'D:/Levis-New-POs/';
  //     const destinationDirectory = 'D:/Levis-Read-POs/';

  //     const files = fs.readdirSync(directoryPath);
  //     for (const file of files) {
  //       await page.waitForSelector('input[type="file"]');
  //       const fileInput = await page.$('input[type="file"]');
  //       const filePath = path.join(directoryPath, file);
  //       await fileInput.uploadFile(filePath);
  //       await page.waitForTimeout(5000);

  //       await page.waitForSelector('button.ant-btn-primary')
  //       await page.click('button.ant-btn-primary');
  //       await page.waitForTimeout(10000)

  //       const sourceFilePath = path.join(directoryPath, file);
  //       const destinationFilePath = path.join(destinationDirectory, file);
  //       fs.rename(sourceFilePath, destinationFilePath, async (err) => {
  //         if (err) {
  //           return new CommonResponseModel(false, 0, '');
  //         }
  //       })
  //     }
  //   } catch (error) {
  //     return new CommonResponseModel(false, 0, error)
  //   } finally {
  //     browser.close()
  //   }
  // }

  @Cron('1 * * * *')
  async levisBot() {
    // const browser = await puppeteer.launch({ headless: false, args: ['--start-maximized'] });
    const browser = await puppeteer.launch({
      headless: false,
      args: ['--start-maximized'],
      executablePath: 'C:\\Program Files (x86)\\Microsoft\\Edge\\Application\\msedge.exe'
    });
    try {
      const page = await browser.newPage();
      await page.setViewport({ width: 1580, height: 900 });

      await page.goto('https://levis.shahiapps.in/', {
        timeout: 100000,
        waitUntil: 'networkidle0',
      });

      await page.waitForSelector('#login-form_username');
      await page.type('#login-form_username', 'levis@gmail.com');

      await page.waitForSelector('#login-form_password');
      await page.type('#login-form_password', 'levis');

      await page.waitForTimeout(2000);
      await page.click('button.ant-btn-primary');
      // await page.waitForNavigation();

      await page.goto('https://levis.shahiapps.in/#/levis/levis-pdf-upload/', {
        timeout: 100000,
        waitUntil: 'networkidle0'
      });

      //     //live directory paths:
      const directoryPath = 'D:/Levis-New-POs/';
      const destinationDirectory = 'D:/Levis-Read-POs/';

      await page.waitForTimeout(4000);
      const files = fs.readdirSync(directoryPath);

      for (const file of files) {
        await page.waitForSelector('input[type="file"]');
        const fileInput = await page.$('input[type="file"]');
        const filePath = path.join(directoryPath, file);
        await fileInput.uploadFile(filePath);
        await page.waitForTimeout(3000);

        await page.waitForSelector('button.ant-btn-primary');
        await page.click('button.ant-btn-primary');

        const response = await page.waitForResponse(response => {
          const contentType = response.headers()['content-type'];
          return contentType && contentType.includes('application/json') && response.ok();
        }, { timeout: 0 });

        if (response.ok()) {
          await page.waitForTimeout(3000);
          const sourceFilePath = path.join(directoryPath, file);
          const destinationFilePath = path.join(destinationDirectory, file);

          try {
            fs.renameSync(sourceFilePath, destinationFilePath);
          } catch (err) {
            console.error(`Error moving file: ${file}`, err);
            return new CommonResponseModel(false, 0, 'File move error');
          }
        }
      }
    } catch (error) {
      console.error('Error during process', error);
      return new CommonResponseModel(false, 0, error);
    } finally {
      if (browser) {
        await browser.close();
      }
    }
  }


  @Cron('*/10 * * * *')
  async editCOline(req: any): Promise<CommonResponseModel> {
    const po = await this.EditRepo.getDataforCOLineEdit();
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.sleep(5000)
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      // for (const po of poDetails) {
      console.log(po)
      const coLine = new CoLineRequest();

      let agent;
      let buyerAddress;
      let deliveryAddress;
      let pkgTerms;
      let paymentTerms;
      let styleNo;
      let coNumber
      if (po.buyer === 'LEVIS') {
        const response = await this.getOrderdataForCOline({ poNumber: po.po_number, poLine: po.po_line })
        console.log(response.data[0], "response")
        console.log(response.data[0].destinations[0].colors[0].sizes, 'CCCCCCCC')
        const coData = response.data[0];
        coLine.buyerPo = coData.poNumber
        // const inputDate = new Date(coData.deliveryDate)
        // Calculate the date 7 days before the GAC date
        // const sevenDaysBefore = new Date(inputDate);
        // sevenDaysBefore.setDate(inputDate.getDate() - 7);
        // const exFactoryDate = new Intl.DateTimeFormat('en-GB').format(sevenDaysBefore);

        coLine.deliveryDate = coData.deliveryDate
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        coLine.exFactoryDate = coData.exfactoryDate
        coLine.coNumber = po.co_number
        console.log(coLine.exFactoryDate, "exFactoryDate")
        console.log(coLine.deliveryDate, "deliveryDate")

        const request = coData.destinations[0]?.name;
        console.log(request, "request")
        const address = await this.AddressService.getAddressInfoByCountry({ country: request });
        const addressData = address.data[0];
        console.log("----------------start----------------")

        if (!addressData) {
          const update = await this.levisCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
          return new CommonResponseModel(false, 0, "Address not matching");
        }

        console.log("----------------end----------------")

        console.log(addressData, "address")
        styleNo = coData.style
        buyerAddress = addressData?.buyerAddressCode
        deliveryAddress = addressData?.deliveryAddressCode
        agent = "-NA"
        pkgTerms = "STD-STD PACK"
        paymentTerms = "063-TT  75 Days"
      }
      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Style Orders')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }
      await driver.wait(until.elementLocated(By.id('styleid2H')))
      await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
      await driver.sleep(5000)
      if (coLine.currency === "INR") {
        await driver.wait(until.elementLocated(By.id('bgpset1')));
        const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
        const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
        await dropdown1.selectByValue("LIV-LIVIS")
        await driver.sleep(5000)

        await driver.wait(until.elementLocated(By.id('byr')));
        const dropdownElement2 = await driver.findElement(By.id('byr'));
        const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
        await dropdown2.selectByValue("LEVI0001-LEVI STRAUSS INDIA PVT LTD")
      } else {
        await driver.wait(until.elementLocated(By.id('bgpset1')));
        const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
        const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
        await dropdown1.selectByValue("LEV-LEVIS")
        await driver.sleep(5000)

        await driver.wait(until.elementLocated(By.id('byr')));
        const dropdownElement2 = await driver.findElement(By.id('byr'));
        const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
        await dropdown2.selectByValue("LEV00002-LEVI STRAUSS GLOBAL TRADING CO LTD")
      }
      await driver.sleep(5000)

      await driver.wait(until.elementLocated(By.id('ViewOrderID')))
      await driver.findElement(By.id('ViewOrderID')).click();
      //   await driver.executeScript("document.body.style.zoom = '80%'");
      // console.log("Screen zoomed out by 80%");

      await driver.sleep(50000)

      let j;
      for (let i = 1; i <= 1000; i++) {
        const buyerpoPath = `//*[@id="form2"]/table/tbody/tr[2]/td/div/table/tbody/tr[${i}]/td[4]`;
        const coNumberPath = `//*[@id="form2"]/table/tbody/tr[2]/td/div/table/tbody/tr[${i}]/td[7]`;
        const BuyerPoelementContainingNumber = await driver.findElement(By.xpath(buyerpoPath));
        const coNumberelementContaining = await driver.findElement(By.xpath(coNumberPath));
        const textContainingBuyerPo = await BuyerPoelementContainingNumber.getText();
        const textContainingCoNumber = await coNumberelementContaining.getText();

        if (textContainingBuyerPo === coLine.buyerPo && textContainingCoNumber === coLine.coNumber) {
          j = i
          break;
        }
      }

      const viewButtonPo = await driver.findElement(By.xpath(`//*[@id="form2"]/table/tbody/tr[2]/td/div/table/tbody/tr[${j}]/td[21]/div`));
      await viewButtonPo.click();

      await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate);
      await driver.wait(until.elementLocated(By.name('dojo.delydt')));
      await driver.findElement(By.name('dojo.delydt')).clear();
      await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate);
      console.log("DeliveryDate end")

      await driver.wait(until.elementLocated(By.name('byd')));
      const dropdown = await driver.findElement(By.name('byd'));
      const options = await dropdown.findElements(By.tagName('option'));
      const optionValues = [];
      for (const option of options) {
        const value = await option.getAttribute('value');
        optionValues.push(value);
      }
      const number = optionValues.find(value => {
        return Number(value.split('-')[0].trim()) == Number(buyerAddress)
      });
      // const number = optionValues.find(value => value.includes(buyerAddress)); // give the dynamic value here
      await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
      await driver.wait(until.elementLocated(By.xpath('//*[@id="cur"]')));
      const curDropdown = await driver.findElement(By.xpath('//*[@id="cur"]'));
      const cur = coLine.currency; // give the dynamic value here
      await driver.executeScript(`arguments[0].value = '${cur}';`, curDropdown);

      await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
      await driver.findElement(By.xpath('//*[@id="price"]')).clear();
      await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice);

      await driver.wait(until.elementLocated(By.id('packtrm')));
      const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
      await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)
      await driver.wait(until.elementLocated(By.id('ptr')));
      const ptrDropDown = await driver.findElement(By.id('ptr'));
      await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)
      for (let dest of coLine.destinations) {
        const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
        const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
        for (const tab of colorsTabs) {
          if ((await tab.getAttribute('innerText')) == dest.name) {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  }
                }
                const inputId = `${size.name}:${color.name}:${dest.name}`.replace(/\*/g, '');
                const input = await driver.wait(until.elementLocated(By.id(inputId)))
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASORTED*') {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                const colorArray: any[] = []
                const sizes: any[] = []
                if (colorIndex === 0) {
                  // Find all the colors 
                  await driver.wait(until.elementLocated(By.xpath(`//*[@id="nameDiv3725PZD001"]/table/tbody/tr/td[1]`)))
                  let colorElements: any[] = await driver.findElements(By.xpath(`//*[@id="nameDiv3725PZD001"]/table/tbody/tr/td[1]`));
                  for (const colorElement of colorElements) {
                    const ele = await colorElement.getAttribute('innerText');
                    colorArray.push(ele);
                  }
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    sizes.push(label)
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                    await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO matching Size found')
                  }
                }
                const colIndex = colorArray.indexOf(color.name)
                const sizeIndex = sizes.indexOf(size.name)
                const inputId = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div/div/table/tbody/tr/td[2]/table/tbody/tr[2]/td/div/table/tbody/tr[${colIndex + 1}]/td[${(sizeIndex + 1) * 2 - 1}]/input[1]`
                console.log(inputId, 'IIIIIIIIIIII')
                const input = await driver.wait(until.elementLocated(By.xpath(inputId)), 20000)
                console.log(input)
                const currentValue = await input.getAttribute('value');
                // Check if the current value is zero
                // if (currentValue !== '0') {
                //   // Clear the input field
                //   await input.clear();
                // }
                // Enter the new quantity
                input.sendKeys(Key.chord(Key.CONTROL, "a"), size.qty);
                // await input.sendKeys(`${size.qty}`);
                // await driver.findElement(By.xpath(inputId));
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                const colorArray: any[] = []
                const sizes: any[] = []
                if (colorIndex === 0) {
                  // Find all the colors 
                  await driver.wait(until.elementLocated(By.xpath(`//*[@id="nameDiv3725PZD001"]/table/tbody/tr/td[1]`)))
                  let colorElements: any[] = await driver.findElements(By.xpath(`//*[@id="nameDiv3725PZD001"]/table/tbody/tr/td[1]`));
                  for (const colorElement of colorElements) {
                    const ele = await colorElement.getAttribute('innerText');
                    colorArray.push(ele);
                  }
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    sizes.push(label)
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                    await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO matching Size found')
                  }
                }
                const colIndex = colorArray.indexOf(color.name)
                const sizeIndex = sizes.indexOf(size.name)
                const inputId = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div/div/table/tbody/tr/td[2]/table/tbody/tr[2]/td/div/table/tbody/tr[${colIndex + 1}]/td[${(sizeIndex + 1) * 2 - 1}]/input[1]`
                console.log(inputId, 'IIIIIIIIIIII')
                const input = await driver.wait(until.elementLocated(By.xpath(inputId)), 20000)
                console.log(input)
                const currentValue = await input.getAttribute('value');
                // Check if the current value is zero
                // if (currentValue !== '0') {
                //   // Clear the input field
                //   await input.clear();
                // }
                // Enter the new quantity
                input.sendKeys(Key.chord(Key.CONTROL, "a"), size.qty);
                // await input.sendKeys(`${size.qty}`);
                // await driver.findElement(By.xpath(inputId));
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASORTED') {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                const colorArray: any[] = []
                const sizes: any[] = []
                if (colorIndex === 0) {
                  // Find all the colors 
                  await driver.wait(until.elementLocated(By.xpath(`//*[@id="nameDiv3725PZD001"]/table/tbody/tr/td[1]`)))
                  let colorElements: any[] = await driver.findElements(By.xpath(`//*[@id="nameDiv3725PZD001"]/table/tbody/tr/td[1]`));
                  for (const colorElement of colorElements) {
                    const ele = await colorElement.getAttribute('innerText');
                    colorArray.push(ele);
                  }
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    sizes.push(label)
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                    await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO matching Size found')
                  }
                }
                const colIndex = colorArray.indexOf(color.name)
                const sizeIndex = sizes.indexOf(size.name)
                const inputId = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div/div/table/tbody/tr/td[2]/table/tbody/tr[2]/td/div/table/tbody/tr[${colIndex + 1}]/td[${(sizeIndex + 1) * 2 - 1}]/input[1]`
                console.log(inputId, 'IIIIIIIIIIII')
                const input = await driver.wait(until.elementLocated(By.xpath(inputId)), 20000)
                console.log(input)
                const currentValue = await input.getAttribute('value');
                // Check if the current value is zero
                // if (currentValue !== '0') {
                //   // Clear the input field
                //   await input.clear();
                // }
                // Enter the new quantity
                input.sendKeys(Key.chord(Key.CONTROL, "a"), size.qty);
                // await input.sendKeys(`${size.qty}`);
                // await driver.findElement(By.xpath(inputId));
              }
            }
          }
        }
      }
      //   await driver.sleep(10000)
      //   const element = await driver.findElement(By.id('createorder')).click();
      //   await driver.wait(until.alertIsPresent(), 40000);
      //   const alert = await driver.switchTo().alert();
      //   console.log(alert, "aleeeee")
      //   await alert.accept();
      //   const alertTextPromise = alert.text_;
      //   const alertText = await alertTextPromise;
      //   console.log(alertText, "alertText");
      //   if (alert) {

      //     const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: alertText, isActive: false });
      //     await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })

      //     await alert.accept();
      //     await driver.sleep(3000)
      //     await driver.navigate().refresh();
      //     driver.quit()
      //     return new CommonResponseModel(false, 0, alertText)
      //   } else {
      //     await driver.sleep(10000)
      //     await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
      //     const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
      //     const coNo = await coNoElement.getAttribute('value');
      //     const currentDate = new Date();
      //     const day = currentDate.getDate().toString().padStart(2, '0');
      //     const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
      //     const year = currentDate.getFullYear().toString().slice(-2);
      //     const currentDateFormatted = `${day}-${month}-${year}`;
      //     if (coNo) {
      //       const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { coNumber: coNo, status: 'Success', coDate: currentDateFormatted, errorMsg: "-" });
      //       await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.SUCCESS })
      //       await driver.sleep(10000)
      //     } else {
      //       const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false });
      //       await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
      //       await driver.sleep(10000)
      //     }
      //   }
      //   return new CommonResponseModel(true, 1, `COline created successfully`)
      // }
      await driver.wait(until.alertIsPresent(), 10000);
      const alert = await driver.switchTo().alert();
      await alert.accept();
      if (await this.isAlertPresent(driver)) {
        const alert = await driver.switchTo().alert();
        const alertText = await alert.getText();
        const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: StatusEnum.FAILED, errorMsg: alertText, isActive: false });
        await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
        return new CommonResponseModel(false, 0, alertText)
      } else {
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
        const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
        const coNo = await coNoElement.getAttribute('value');
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        if (coNo) {
          const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { coNumber: coNo, status: 'Success', coDate: currentDateFormatted, errorMsg: "-" });
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.SUCCESS })
          return new CommonResponseModel(true, 1, "COline created successfully");
        } else {
          // const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false });
          // await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: 'Failed' })
          const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false });
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
          const emailBot = await this.getCoLineDataAndSendEmail()
          console.log(emailBot, "emailBotTimeOut")
          await driver.sleep(2000)
        }
      }
      return new CommonResponseModel(true, 1, `COline created successfully`)
    } catch (err) {
      console.log(err, 'error');
      const update = await this.levisCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false });
      await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
      const emailBot = await this.getCoLineDataAndSendEmail()
      console.log(emailBot, "emailBotTimeOut")
      return new CommonResponseModel(false, 0, err)
    }
    finally {
      driver.quit()
    }
  }

  // async getOrderReportData(req?: LevisOrderFilter): Promise<CommonResponseModel> {
  //   console.log(req, "servvv")
  //   try {
  //     const details = await this.LevisOrdersRepo.getOrderReportData(req);
  //     if (details.length === 0) {
  //       return new CommonResponseModel(false, 0, 'No data Found');
  //     }
  //     const sizeDateMap = new Map<string, levisOrderReport>();
  //     for (const rec of details) {
  //       if (!sizeDateMap.has(`${rec.po_number}`)) {
  //         sizeDateMap.set(
  //           `${rec.po_number}`,
  //           new levisOrderReport(rec.id,rec.brand,rec.seasonCode,rec.division,rec.merchant,rec.itemNo,rec.factory,rec.region,rec.destinationCode,
  //             rec.destination,rec.styleNo,rec.po_number,rec.unitPrice,rec.fabric,rec.description,rec.process,rec.color,rec.pcd,rec.ftyDiscussion,
  //             rec.originalFty,rec.gtnWeeks,rec.factoryDeliveryDate,rec.shipMode,rec.improvementDeferment,rec.plannedFty,rec.fOneDate,
  //             rec.shippedQuantity,rec.truckDate,rec.cartsClosedDate,rec.shortageExcess,rec.extraShort,rec.shippedQtyValue,
  //             rec.poHeader,rec.remarks,rec.deliveryAddress,rec.quantity,rec.status,[])
  //         );

  //       }
  //       const sizeWiseData = sizeDateMap.get(`${rec.po_number}`).sizeWiseData;
  //       const existingSizeData = sizeWiseData.find(item => item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unitPrice);
  //       if (!existingSizeData && rec.size !== null) {
  //         sizeWiseData.push(new LevisSizeWiseReportModel(rec.size,rec.quantity,rec.unitPrice));
  //       }
  //     }
  //     const dataModelArray: levisOrderReport[] = Array.from(sizeDateMap.values());

  //     return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);



  //   } catch (e) {
  //     console.log(e, "errrrrrrrrr")
  //     return new CommonResponseModel(false, 0, 'failed', e);
  //   }
  // }

  async getOrderReportData(req?: LevisOrderFilter): Promise<CommonResponseModel> {
    // console.log(req, "servvv")

    try {
      const details = await this.LevisOrdersRepo.getOrderReportData(req);
      const coLineDetails = await this.levisCoLineRepo.getCoLineData();
      // console.log(details, "mainDetails")
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, levisOrderReportDataModel>();
      for (const rec of details) {
        const colorcheck = await this.colorRepo.findOne({
          where: {
            colorCode: rec.material
          }
        });

        const ordersMatching = await this.LevisOrdersRepo.findOne({
          where: {
            deliveryAddress: rec.delivery_address
          }
        });
        // console.log(ordersMatching, "ordersMatching");

        if (ordersMatching) {
          // console.log(ordersMatching.deliveryAddress, "ordersDeliveryAddress");
        }

        const addressMatching = await this.AddressRepo.findOne({
          where: {
            deliveryAddress: rec.delivery_address
          }
        });

        if (addressMatching) {
          // console.log(addressMatching.deliveryAddress, "addressDeliveryAddress");
        }

        if (ordersMatching && addressMatching && ordersMatching.deliveryAddress === addressMatching.deliveryAddress) {
          // console.log(addressMatching.destination, "addressMatchingDestination");
        }
        const itemNoData = coLineDetails.map(i => i.item_no);
        const findItemNo = await this.levisCoLineRepo.find({
          where: {
            itemNo: In(itemNoData)
          }
        });
        let coLineItemNo;
        for (const item of findItemNo) {
          if (rec.po_number === item.poNumber) {
            coLineItemNo = item.itemNo;
          }
        }

        const destinationData = addressMatching?.destination
        // console.log(destinationData,"destinationData")
        const color = colorcheck?.colorName

        const key = `${rec.po_line},${rec.po_number},${rec.delivery_date},${color}`;
        if (!sizeDateMap.has(key)) {
          const newData = new levisOrderReportDataModel(
            rec.id,
            rec.po_number,
            rec.season_code,
            rec.po_recevied_date,
            rec.transmode,
            rec.unit_price,
            rec.delivery_address,
            rec.currency,
            rec.po_line,
            rec.material,
            rec.total_unit_price,
            rec.original_date,
            rec.status,
            [],
            rec.ex_factory_date,
            color,
            destinationData,
            rec.po_remarks
          );

          if (coLineItemNo) {
            newData.itemNo = coLineItemNo;
          }

          sizeDateMap.set(key, newData);
        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_line},${rec.po_number},${rec.delivery_date},${color}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.size === rec.size && item.quantity === rec.quantity);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new LevisSizeWiseModel(rec.product, rec.size, rec.upc, rec.planned_ex_factory_date, rec.ex_factory_date, rec.quantity, rec.item_no));
        }
      }
      const dataModelArray: levisOrderReportDataModel[] = Array.from(sizeDateMap.values());

      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);



    } catch (e) {
      console.log(e, "errrrrrrrrr")
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async getSplitOrderComparisionData(req: any): Promise<CommonResponseModel> {
    console.log(req, "req");
    const data = await this.LevisOrdersRepo.getSplitOrderComparisionData(req);
    console.log("data", data);

    if (data.length) {
      const splitPoSizesMap = new Map();
      const splitPoQuantitiesMap = new Map();

      const splitPoNumbers = [...new Set(data.filter(rec => rec.split_po !== null && rec.split_po !== "-").map(rec => rec.split_po))];

      const splitPoSizes = await this.LevisOrdersRepo.find({
        select: ['poNumber', 'size', 'splitPoTotalQuantity', 'quantity'],
        where: { poNumber: In(splitPoNumbers) }
      });

      for (const record of splitPoSizes) {
        if (!splitPoSizesMap.has(record.poNumber)) {
          splitPoSizesMap.set(record.poNumber, []);
        }
        splitPoSizesMap.get(record.poNumber).push({ size: record.size, quantity: record.quantity });

        if (!splitPoQuantitiesMap.has(record.poNumber)) {
          splitPoQuantitiesMap.set(record.poNumber, record.splitPoTotalQuantity || null);
        }
      }

      for (const rec of data) {
        if (rec.split_po !== null && rec.split_po !== "-") {
          const sizes = splitPoSizesMap.get(rec.split_po);
          rec.split_po_total_quantity = splitPoQuantitiesMap.get(rec.split_po);

          if (sizes && sizes.length > 0) {
            const sizeObj = sizes.shift();
            rec.splitPoSize = sizeObj.size;
            rec.splitPoQuantity = sizeObj.quantity;
          } else {
            rec.splitPoSize = "-";
            rec.splitPoQuantity = null;
          }
        } else {
          rec.splitPoSize = "-";
          rec.splitPoQuantity = null;
          rec.split_po_total_quantity = null;
        }
      }

      return new CommonResponseModel(true, 1, 'Data retrieved', data);
    } else {
      return new CommonResponseModel(false, 0, 'No data found');
    }
  }


  //   async getSplitOrderComparisionData(req: any): Promise<CommonResponseModel> {
  //     console.log(req, "req");
  //     const data = await this.LevisOrdersRepo.getSplitOrderComparisionData(req);
  //     console.log("data", data);
  //     if (data.length) {
  //         for (const rec of data) {
  //             if (rec.split_po !== null && rec.split_po !== "-") {
  //                 const splitQty = await this.LevisOrdersRepo.findOne({
  //                     select: ['splitPoTotalQuantity'],
  //                     where: { poNumber: rec.split_po }
  //                 });
  //                 rec.split_po_total_quantity = splitQty?.splitPoTotalQuantity || null;

  //                 const splitPoSize = await this.LevisOrdersRepo.findOne({
  //                     select: ['size'],
  //                     where: { poNumber: rec.split_po }
  //                 });
  //                 rec.splitPoSize = splitPoSize?.size || null; 

  //                 console.log(splitPoSize, "splitPoSize");
  //             }

  //         }
  //         return new CommonResponseModel(true, 1, 'Data retrieved', data);
  //     } else {
  //         return new CommonResponseModel(false, 0, 'No data found');
  //     }
  // }

  // const poSizees = await this.LevisOrdersRepo.findOne({
  //     select: ['size'],
  //     where: { poNumber: rec.po_number }
  // });
  // rec.size = poSizees?.size || null;

  // console.log(poSizees, "poSizees");


  async editCoLineCreationReq(req: any): Promise<CommonResponseModel> {
    try {
      // console.log(req,'req')
      if (req.itemNo == undefined || null) {
        return new CommonResponseModel(false, 0, 'Please enter Item No')
      };
      // const update= await this.Repo.update({ where:{ poNumber: req.poNumber ,status:StatusEnum.ACCEPTED}})
      const records = await this.LevisOrdersChildRepo.find({ where: { poNumber: req.poNumber } });
      const uniquePoLines = [...new Set(records.map((rec) => rec.poLine))];
      const empty = [];

      //console.log(rec,'reccccccccc')
      const entity = new EditLevisCOLineEntity()
      entity.poLine = uniquePoLines.join(',');
      entity.buyer = req.buyer
      entity.poNumber = req.poNumber;
      entity.material = req.material;
      entity.itemNo = req?.itemNo;
      entity.status = 'Open';
      // entity.deliveryDate = req.deliveryDate;
      entity.createdUser = 'admin';
      entity.coDate = req?.coDate;
      entity.coNumber = req?.coNumber
      empty.push(entity)

      // console.log(empty,'emptyyyyy')
      const save = await this.EditRepo.save(empty);



      if (save) {
        const update = await this.LevisOrdersChildRepo.update(
          { poNumber: req.poNumber }, // Conditions for updating
          { status: StatusEnum.INPROGRESS }
        );
        return new CommonResponseModel(true, 1, 'Edit CO-Line request created successfully', save)
      } else {
        return new CommonResponseModel(false, 0, 'CO-Line request failed')
      }
    } catch (err) {
      //  console.log(err,',,,,,,,,,,,,,,,')
      return new CommonResponseModel(false, 0, 'CO-Line request failed', err)
    }
  }

  async getEditCoLineData(req?: LevisOrderFilter): Promise<CommonResponseModel> {
    const data = await this.EditRepo.getEditCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getEditCoPoNumber(): Promise<CommonResponseModel> {
    const data = await this.EditRepo.getEditCoPoNumber()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getEditItem(): Promise<CommonResponseModel> {
    try {
      const data = await this.EditRepo.getEditItem()
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getHistoryPoNumber(): Promise<CommonResponseModel> {
    try {
      const data = await this.pdfRepo.getHistoryPoNumber()
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async deleteEditCoLine(req: ItemNoDtos): Promise<CommonResponseModel> {
    console.log(req, "reqq");
    try {
      const deletedItem = await this.EditRepo.delete({ id: Number(req.id) });

      if (deletedItem && deletedItem.affected) {
        return new CommonResponseModel(true, 1, "ItemNo Deleted Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  async updateStatusInOrderAcceptance(req: any): Promise<CommonResponseModel> {
    console.log(req, "reqOpenStatus")
    try {
      const update = await this.LevisOrdersChildRepo.update(
        { poNumber: req.poNumber },
        { status: StatusEnum.OPEN }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "Updated Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  async getPdfFromBuyerPortal(): Promise<CommonResponseModel> {
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('https://sapportal.levi.com/irj/portal/')
      await driver.findElement(By.id('logonuidfield')).sendKeys('9selva1');
      await driver.findElement(By.id('logonpassfield')).sendKeys('Mnreak@123');
      await driver.findElement(By.xpath('//*[@id="certLogonForm"]/table/tbody/tr[5]/td[2]/input')).click();
      console.log("0000")
      await driver.sleep(20000)
      // await driver.switchTo().frame(By.id("ivuFrm_page0ivu2"))
      // await driver.switchTo().defaultContent()
      // const frame1Old = await driver.findElement(By.id("ivuFrm_page0ivu2"))
      // await driver.switchTo().frame(frame1Old)
      const frame1 = await driver.findElement(By.id("ivuFrm_page0ivu2"))
      await driver.switchTo().frame(frame1)
      console.log(frame1, "frame1")
      const iframe2 = await driver.findElement(By.id("ivuFrm_page0ivu0"))
      await driver.switchTo().frame(iframe2)
      console.log(iframe2, "iframe2")

      await driver.sleep(4000)

      const purchaseOrderButton = await driver.findElement(By.id('WD35')).click()
      console.log(purchaseOrderButton, "Purchase Order Clicked")

      let fgPurchaseOrderWorklistButton = await driver.wait(until.elementLocated(By.xpath("//span[contains(text(), 'FG Purchase Order Worklist')]")), 10000);
      await fgPurchaseOrderWorklistButton.click();
      console.log("FG Purchase Order Worklist Clicked")
      await driver.sleep(4000)

      await driver.findElement(By.xpath('//*[@id="WD02CC"]')).click();
      console.log("PO Items Navigation Clicked")
      await driver.sleep(45000)

      await driver.findElement(By.xpath('//*[@id="WD02E0"]')).click();
      console.log("Show Qucik Criteria Clicked")
      await driver.sleep(10000)

      await driver.executeScript("window.scrollBy(0, 200)");
      await driver.sleep(5000)

      const openCheckBox = await driver.findElement(By.xpath('//*[@id="WD08AF-r"]'));
      await openCheckBox.click()
      console.log("Open Check Box Clicked")
      await driver.sleep(4000)


      const cartonizedCheckBox = await driver.findElement(By.xpath('//*[@id="WD08B6-r"]'));
      await cartonizedCheckBox.click()
      console.log("Cartonized Check Box Clicked")
      await driver.sleep(4000)

      const applyButton = await driver.findElement(By.xpath('//*[@id="WD08CF"]/span[1]'));
      await applyButton.click()
      console.log("Apply Button Clicked")
      await driver.sleep(20000)

      await driver.executeScript("window.scrollTo(0, document.body.scrollHeight)");
      await driver.sleep(3000)

      console.log("Selecting PO'S")
      const rows = await driver.findElements(By.css('tr[role="row"]'));
      const rowsToSelect = Math.min(15, rows.length);
      const firstRow = rows[0];
      const lastRow = rows[rowsToSelect - 1];
      const actions = driver.actions({ bridge: true });
      await actions.keyDown(Key.SHIFT).click(lastRow).keyUp(Key.SHIFT).perform();
      await driver.sleep(4000);

      // const selectMenu = await driver.findElement(By.xpath('//*[@id="WD0919"]'));
      // await selectMenu.click()
      // console.log("Select Menu Clicked")
      // await driver.sleep(3000)

      // let selectAllButton = await driver.wait(until.elementLocated(By.xpath("//span[contains(text(), 'Select All')]")), 10000);
      // await selectAllButton.click();
      // console.log("Select All Clicked")
      // await driver.sleep(4000)

      const printButton = await driver.findElement(By.xpath('//*[@id="WD0909"]/span'));
      await printButton.click()
      console.log("Print Button Clicked")

      console.log("Loading....")
      // await driver.wait(until.stalenessOf(await driver.findElement(By.xpath('//*[@id="ur-loading"]/div'))));
      await driver.sleep(60000)

      console.log("Loading Completed in Portal")

      await driver.sleep(2000)

      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);



      let numberOfTabs = windowHandles.length;
      let tabs = windowHandles;
      let nextTab = windowHandles[1];
      console.log("Number of tabs:", numberOfTabs);
      console.log("tabs:", tabs);
      console.log("nextTab:", nextTab);

      console.log("Switched to the next tab");
      await driver.sleep(2000)


      const iframe = await driver.findElement(By.css('iframe[type="application/pdf"]'));

      // Switch to the iframe
      await driver.switchTo().frame(iframe);
      await driver.sleep(2000)

      await driver.findElement(By.id("viewer"));
      console.log("111");

      await driver.findElement(By.tagName("viewer-toolbar"));
      console.log("222");

      await driver.findElement(By.tagName("viewer-download-controls"));
      console.log("333");

      await driver.findElement(By.tagName("cr-icon-button"));
      console.log("444");

      const ironIconButton = await driver.findElement(By.id("download"));
      console.log("555");
      await ironIconButton.click();



      // console.log("switching to first tab")
      // await driver.switchTo().window(windowHandles[0]);
      // console.log("switched to first tab")
      // console.log("button clicking in  first tab")

      // const applyButton2 = await driver.findElement(By.xpath('//*[@id="WD08CF"]/span[1]'));
      // await applyButton2.click()
      // console.log("Apply Button Clicked")
      // await driver.sleep(20000)

      // await driver.wait(until.titleContains('OUTPUT.PDF'), 10000);

      // const titleTab = await driver.getTitle();
      // console.log("Title of the new tab:", titleTab);

      //   const viewer = await driver.findElement(By.id('viewer'));
      //   // const tagName = await viewer.getTagName();
      //   // console.log("Tag name of the element:", tagName);
      //  console.log(viewer,"vvvvvvvvvv")
      //   // const downloadButton = await driver.findElement(By.xpath('//*[@id="download"]'));
      //   // await downloadButton.click();
      //   console.log("PDF Download Button Clicked");
      //   await driver.sleep(6000)
      console.log("*******Completed******")

    } catch (error) {
      console.log(error, "eeeeeeeeer")
      return new CommonResponseModel(false, 0, error)
    }
  }


  async extractTextFromPDFWithPage(filePath, pageNumber: number) {
    const dataBuffer = fs.readFileSync(filePath);
    let max = pageNumber;
    return await PDFParser(dataBuffer, {
      max: max, pagerender: function daaaaaa(pageData) {
        if (max - 1 != pageData.pageIndex) {
          throw null;
        }
        let render_options = {
          //replaces all occurrences of whitespace with standard spaces (0x20). The default value is `false`.
          normalizeWhitespace: false,
          //do not attempt to combine same line TextItem's. The default value is `false`.
          disableCombineTextItems: false
        }
        return pageData.getTextContent(render_options)
          .then(function (textContent) {
            let lastY, text = '';
            for (let item of textContent.items) {
              if (lastY == item.transform[5] || !lastY) {
                text += item.str;
              }
              else {
                text += '\n' + item.str;
              }
              lastY = item.transform[5];
            }
            return text;
          });
        return pageData.text;
      }
    }).then((data) => {
      console.log(data);
      console.log('-------INSIDE PDF PARSER FOR PAGE-------------');
      return (data.text);
    }).catch(err => {
      return "";
    });
  }

  async extractTextFromPDF(filePath) {
    console.log('a');
    // return new Promise((resolve, reject) => {
    const dataBuffer = fs.readFileSync(filePath);
    console.log('b');
    return await PDFParser(dataBuffer).then((data) => {
      console.log('c');
      return data.text;
      // resolve(data.text);
    }).catch((error) => {
      // reject(error);
      console.log(error);
      return "";
    });
  }


  @Cron('*/30 * * * *')
  async splitPdfs(): Promise<CommonResponseModel> {
    try {
      const mergedFilePath = 'D:/Levis-Merged-PO/';
      // const directoryPath = 'D:/levis-unread/';
      const processedFilePath = "D:/Levis-Merged-Read-POs/"
      const mergedFiles = fs.readdirSync(mergedFilePath);

      for (const mergedFile of mergedFiles) {
        const categoryWisePages = {
          lsePage: new Set<number>(),
          mxPage: new Set<number>(),
          brPage: new Set<number>(),
        };

        const filePath = `${mergedFilePath}${mergedFile}`;
        const mergedPdfBytes = fs.readFileSync(filePath);
        const mergedPdf = await PDFDocument.load(mergedPdfBytes);

        const totalPages = mergedPdf.getPageCount();
        const textContent: any = await this.extractTextFromPDF(filePath);

        const lsePageMatches = textContent.match(/Page: \d+ of \d+/g);
        const mxPageMatches = textContent.match(/Purchase\s+Order#\s+(\d+)/g);
        const brPageMatches = textContent.match(/(\d+)\s*LEVIS\s*(\d+)/g);

        for (const text of lsePageMatches || []) {
          let page = 1;
          while (page <= totalPages) {
            const currPageContent: any = await this.extractTextFromPDFWithPage(filePath, page);
            const textFoundInPage = currPageContent.match(text);
            if (textFoundInPage) {
              categoryWisePages.lsePage.add(page);
            }
            page++;
          }
        }
        console.log(categoryWisePages, "LSE-CATO")

        for (const text of mxPageMatches || []) {
          let page = 1;
          while (page <= totalPages) {
            const currPageContent: any = await this.extractTextFromPDFWithPage(filePath, page);
            const textFoundInPage = currPageContent.match(text);
            if (textFoundInPage) {
              categoryWisePages.mxPage.add(page);
            }
            page++;
          }
        }
        console.log(categoryWisePages, "MX-CATO")

        for (const text of brPageMatches || []) {
          let page = 1;
          while (page <= totalPages) {
            const currPageContent: any = await this.extractTextFromPDFWithPage(filePath, page);
            const textFoundInPage = currPageContent.match(text);
            if (textFoundInPage) {
              categoryWisePages.brPage.add(page);
            }
            page++;
          }
        }
        console.log(categoryWisePages, "BR-CATO")

        if (categoryWisePages.lsePage.size > 0) {
          await this.lseSplit(categoryWisePages, mergedPdf, mergedFile, lsePageMatches, filePath);
        }
        if (categoryWisePages.mxPage.size > 0) {
          await this.mxSplit(categoryWisePages, mergedPdf, mergedFile, mxPageMatches, filePath);
        }
        if (categoryWisePages.brPage.size > 0) {
          await this.brSplit(categoryWisePages, mergedPdf, mergedFile, brPageMatches, filePath);
        }
        // fs.unlinkSync(filePath);
        const newFilePath = `${processedFilePath}${mergedFile}`;
        fs.renameSync(filePath, newFilePath);
      }

      return new CommonResponseModel(true, 1, 'PDF splitting completed successfully');
    } catch (error) {
      return new CommonResponseModel(false, 0, error);
    }
  }



  async lseSplit(categoryWisePages: any, mergedPdf: PDFDocument, mergedFile: string, lsePageMatches: RegExpMatchArray | null, filePath: string) {
    try {
      const lsePages: any = Array.from(categoryWisePages['lsePage']).sort((a, b) => Number(a) - Number(b));
      console.log(lsePages, "lsePagessss");
      const directoryPath = 'D:/Levis-New-POs/';
      let i = 0;
      while (i < lsePages.length) {
        const startPage = lsePages[i];
        const match = lsePageMatches?.find((rec) => rec.match(/Page:\s+\d+\s+of\s+\d+/g));
        const poMatch = lsePageMatches?.[i].match(/PO NUMBER/g);
        console.log(poMatch, "poMatchsdddd")

        if (match) {
          const totalPages = Number(match.split('of')[1]);
          const endPage = startPage + totalPages - 1;
          const newPdf = await PDFDocument.create();

          for (let j = startPage - 1; j < endPage; j++) {
            if (lsePages.includes(j + 1)) {
              const [copiedPage] = await newPdf.copyPages(mergedPdf, [j]);
              newPdf.addPage(copiedPage);
            }
          }

          const splitFilename = `${mergedFile.replace('.pdf', '')}_Page${startPage}_to_Page${endPage}.pdf`;
          const splitFilePath = `${directoryPath}${splitFilename}`;

          const splitPdfBytes = await newPdf.save();
          fs.writeFileSync(splitFilePath, splitPdfBytes);

          console.log(`Created split PDF: ${splitFilePath}`);
          i += totalPages;
        } else {
          i += 1;
        }
      }
    } catch (error) {
      console.error("Error occurred while splitting LSE pages:", error);
    }
  }


  async mxSplit(categoryWisePages: any, mergedPdf: PDFDocument, mergedFile: string, mxPageMatches: RegExpMatchArray | null, filePath: string) {
    try {
      if (!mxPageMatches) {
        console.log("No MX page matches found.");
        return;
      }

      const mxPages: any = Array.from(categoryWisePages.mxPage).sort((a, b) => Number(a) - Number(b));
      const directoryPath = 'D:/Levis-New-POs/';
      const pdfsMap = new Map<number, Map<number, number>>();
      let splitIndex = 0;

      for (let i = 0; i < mxPages.length; i++) {
        const poNumber = mxPageMatches[i].match(/\d+$/)[0];
        const fromAndToPages = new Map<number, number>();
        let j = i;

        while (j < mxPages.length && mxPageMatches[j].match(/\d+$/)[0] === poNumber) {
          j++;
        }

        fromAndToPages.set(mxPages[i], mxPages[j - 1]);
        pdfsMap.set(Number(poNumber), fromAndToPages);
        i = j - 1;
      }

      await Promise.all(Array.from(pdfsMap).map(async ([poNumber, fromAndToPages]) => {
        const newPdf = await PDFDocument.create();
        const currentPage = Array.from(fromAndToPages.keys())[0];
        const endPage = fromAndToPages.get(currentPage);

        const splitFilename = `${poNumber}.pdf`;
        const splitFilePath = `${directoryPath}${splitFilename}`;

        for (let j = currentPage - 1; j < endPage; j++) {
          const [copiedPage] = await newPdf.copyPages(mergedPdf, [j]);
          newPdf.addPage(copiedPage);
        }

        const splitPdfBytes = await newPdf.save();
        fs.writeFileSync(splitFilePath, splitPdfBytes);
      }));

    } catch (error) {
      console.error("Error occurred while splitting MX pages:", error);
    }
  }


  // async brSplit(categoryWisePages: any, mergedPdf: PDFDocument, mergedFile: string, brPageMatches: RegExpMatchArray | null, filePath: string) {
  //   try {
  //     const brPages = Array.from(categoryWisePages.brPage).sort((a, b) => Number(a) - Number(b));
  //     const directoryPath = 'D:/levis-unread/';
  //     const pdfsMap = new Map();

  //     let i = 0;
  //     while (i < brPages.length) {
  //       const poNumber = brPageMatches[i].match(/\b\d+\b/)[0];
  //       console.log(poNumber, "pooooooooNumber")
  //       const fromAndToPages = new Map();
  //       let j = i;

  //       while (j < brPages.length && brPageMatches[j].match(/\b\d+\b/)[0] === poNumber) {
  //         j++;
  //       }

  //       fromAndToPages.set(brPages[i], brPages[j - 1]);
  //       pdfsMap.set(Number(poNumber), fromAndToPages);
  //       i = j;
  //     }

  //     await Promise.all(Array.from(pdfsMap.entries()).map(async ([poNumber, fromAndToPages]) => {
  //       const newPdf = await PDFDocument.create();
  //       const startPage: any = Array.from(fromAndToPages.keys())[0];
  //       const endPage = fromAndToPages.get(startPage);
  //       const splitFilename = `${poNumber}.pdf`;
  //       const splitFilePath = `${directoryPath}${splitFilename}`;

  //       for (let j = startPage - 1; j <= endPage - 1; j++) {
  //         const [copiedPage] = await newPdf.copyPages(mergedPdf, [j]);
  //         newPdf.addPage(copiedPage);
  //       }
  //       const splitPdfBytes = await newPdf.save();
  //       fs.writeFileSync(splitFilePath, splitPdfBytes);
  //     }));

  //   } catch (error) {
  //     console.error("Error occurred while splitting BR pages:", error);
  //   }
  // }

  async brSplit(categoryWisePages: any, mergedPdf: PDFDocument, mergedFile: string, brPageMatches: RegExpMatchArray | null, filePath: string) {
    try {
      const brPages = Array.from(categoryWisePages.brPage).sort((a, b) => Number(a) - Number(b));
      console.log(brPages, "brPages");
      const directoryPath = 'D:/Levis-New-POs/';
      const pdfsMap = new Map();

      for (let i = 0; i < brPages.length; i++) {
        const page = brPages[i];
        const poMatch = brPageMatches?.[i].match(/\b\d+\b/);
        console.log(poMatch, "poMatch");
        if (poMatch) {
          const poNumber = poMatch[0];
          if (!pdfsMap.has(poNumber)) {
            pdfsMap.set(poNumber, []);
          }
          pdfsMap.get(poNumber).push(page);
        }
      }

      await Promise.all(Array.from(pdfsMap.entries()).map(async ([poNumber, pages]) => {
        const newPdf = await PDFDocument.create();
        const splitFilename = `${poNumber}.pdf`;
        const splitFilePath = `${directoryPath}${splitFilename}`;

        for (const page of pages) {
          const [copiedPage] = await newPdf.copyPages(mergedPdf, [page - 1]);
          newPdf.addPage(copiedPage);
        }
        const splitPdfBytes = await newPdf.save();
        fs.writeFileSync(splitFilePath, splitPdfBytes);
      }));

    } catch (error) {
      console.error("Error occurred while splitting BR pages:", error);
    }
  }


  // async saveFormatWisePdfs(categoryWisePages: any, mergedPdf: PDFDocument, mergedFile: string) {
  //   const categories = Object.keys(categoryWisePages);

  //   for (const category of categories) {
  //     const pageNumbers = Array.from(categoryWisePages[category]).sort();
  //     const newPdf = await PDFDocument.create();
  //     const pages = await newPdf.copyPages(mergedPdf, pageNumbers.map(page => page as number - 1));

  //     for (const page of pages) {
  //       newPdf.addPage(page);
  //     }

  //     const newPdfBytes = await newPdf.save();
  //     fs.writeFileSync(`D:/levis-unread/${category}_${mergedFile}`, newPdfBytes);
  //   }
  // }



  // async getCoLineDataAndSendEmail(): Promise<CommonResponseModel> {
  //   const recipientEmail = 'santhosh.palaksha@shahi.co.in';
  //   const ccEmails = ['saiprakash.katiki@gmail.com', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com', 'bala.arumugam@shahi.co.in', 'moshika.murugan@shahi.co.in', 'priya.prabhakaran@shahi.co.in', 'senguttuvan.ilangovan@shahi.co.in', 'vignesh.prabhakaran@shahi.co.in', 'santhosh.palaksha@shahi.co.in'];
  //   const response = await this.levisCoLineRepo.getCoLineData();
  //   const data = response;

  //   const failedPoNumbersData = [];
  //   data.forEach(po => {
  //     if (po.po_number && (po.status === 'Failed')) {
  //       failedPoNumbersData.push(po.po_number);
  //     }
  //   });
  //   const coLineFailedData = data.filter(item => item.status === 'Failed');
  //   if (coLineFailedData.length > 0) {
  //     const errorMessage = coLineFailedData.map(item => `
  //         PO Number: ${item.po_number}
  //         Buyer Name: Levis
  //         PO Line: ${item.po_line}
  //         PLM Style: ${item.material}
  //         Item No: ${item.item_no}
  //         CO Number: ${item.co_number}
  //         CO Date: ${item.co_date}
  //         Status: ${item.status}
  //         Message: ${item.error_msg}
  //       `).join('\n\n');

  //     const transporter = nodemailer.createTransport({
  //       host: 'smtp.gmail.com',
  //       port: 587,
  //       secure: false,
  //       auth: {
  //         user: 'alerts@schemaxtech.com',
  //         pass: 'mzep lrqi mczj uezj'
  //       }
  //     });

  //     const mailOptions = {
  //       from: 'alerts@schemaxtech.com',
  //       to: recipientEmail,
  //       cc: ccEmails,
  //       subject: 'Levis CO Line Failed Status',
  //       text: `Dear User,\n\n Levis CO Line Data:\n\n${errorMessage}\n\nRegards,\nLevis BOT`,
  //     };

  //     await transporter.sendMail(mailOptions);
  //     return new CommonResponseModel(true, 1, "Email Sent Successfully");
  //   } else {
  //     return new CommonResponseModel(false, 0, "No Records with Failed status");
  //   }
  // }
}